module.exports = __webpack_public_path__ + "img/oops.268f3d44.svg";